


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Button, Container, Typography, Box, Snackbar, Alert } from '@mui/material';
import { setName, setEmail, setPhone, setMessage, clearForm, setIsSubmitted } from '../features/contactSlice';
import axios from 'axios';
import { AddContct } from '../utils/lookupUtil';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from "react-router-dom";

export default function ContactForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { name, email, phone, message, isSubmitted } = useSelector((state) => state.contact);
    const [errors, setErrors] = useState({});
    const [submissionError, setSubmissionError] = useState(null);
    const { loggedUser, isLoggedIn } = useSelector((state) => state.user);
    const userState = useSelector((state) => state.user);
    console.log("userState:", userState);

    console.log("loggedUser:", loggedUser);
    // const userState = useSelector((state) => state.user);
    // console.log("userState:", userState);
    // console.log("loggedUser:", userState?.loggedUser);

    const requireLogin = () => {
        if (!isLoggedIn) {
            Swal.fire({
                icon: "info",
                title: "צריך להתחבר כדי לשלוח פנייה",
                text: "העברה לעמוד התחברות/הרשמה",
                confirmButtonText: "הבנתי",
                // 🔹 צבע הכפתור
                confirmButtonColor: "#D81B60",

                // 🔹 צבע האייקון (i / סימן קריאה / סימן שאלה)
                iconColor: "#58A76B",

                // 🔹 מחיל את העיצוב הקיים שלך בלי לשנות CSS
                customClass: {
                    popup: "custom-swal"
                }

            }).then(() => navigate("/signin", { state: { from: location.pathname } }));
            return true;
        }
        return false;
    };

    useEffect(() => {
        if (isLoggedIn && loggedUser) {
            if (!name) dispatch(setName(loggedUser.name || ""));
            if (!email) dispatch(setEmail(loggedUser.email || ""));
            if (!phone) dispatch(setPhone(loggedUser.phone || "")); // ✅ חדש
        }
    }, [isLoggedIn, loggedUser, name, phone, email, dispatch]);



    const validate = () => {
        const newErrors = {};
        if (!name) newErrors.name = "שם הוא שדה חובה";
        if (!email) {
            newErrors.email = "אימייל הוא שדה חובה";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = "אנא הכנס כתובת אימייל חוקית";
        }
        if (!message) newErrors.message = "הודעה היא שדה חובה";
        if (!phone) {
            newErrors.phone = "טלפון הוא שדה חובה";
        } else if (!/^[0-9]{9,10}$/.test(phone)) {
            newErrors.phone = "מספר טלפון לא חוקי";
        }
        return newErrors;

    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // ✅ גם בשליחה חובה להיות מחובר (לא רק בהקלדה)
        if (requireLogin()) return;
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            AddContct({
                name,
                email,
                phone,
                massages: message,
            }).then(res => {
                if (res.status === 200) {
                    dispatch(clearForm());
                    dispatch(setIsSubmitted(true));
                    setErrors({});
                    setSubmissionError(null);
                  Swal.fire({
  title: 'פנייתך נשלחה!',
  icon: 'success',

  // 🎀 כפתור ורוד
  confirmButtonColor: '#D81B60'
});
                }
                else
                    setSubmissionError("Failed to send the message. Please try again.");

            })

        }
    };

    const handleBack = () => {
        dispatch(setIsSubmitted(false));  // חזרה למצב שלפני השליחה
    };

    return (
        <Container maxWidth="sm">
            {isSubmitted ? (
                <Box textAlign="center" mt={4}>
                    <Alert severity="success">
                        הפנייה נשלחה בהצלחה!
                    </Alert>
                    <Button variant="contained" color="primary" onClick={handleBack} sx={{ mt: 2 }}>
                        חזור
                    </Button>
                </Box>
            ) : (
                <>
                    <Typography variant="h4" align="center" gutterBottom>
                        צור קשר
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <Box mb={2}>
                            <TextField
                                fullWidth
                                label="שם"
                                variant="outlined"
                                value={name}
                                onFocus={() => requireLogin()}   // ✅ ברגע שנכנסים לשדה
                                onChange={(e) => {
                                    if (requireLogin()) return;    // ✅ ברגע שמנסים להקליד
                                    dispatch(setName(e.target.value));
                                }}
                                error={!!errors.name}
                                helperText={errors.name}
                                required
                            />
                        </Box>
                        <Box mb={2}>
                            <TextField
                                fullWidth
                                label="אימייל"
                                variant="outlined"
                                value={email}
                                onChange={(e) => dispatch(setEmail(e.target.value))}
                                error={!!errors.email}
                                helperText={errors.email}
                                required
                            />
                        </Box>
                        <Box mb={2}>
                            <TextField
                                fullWidth
                                label="טלפון"
                                variant="outlined"
                                value={phone}
                                onChange={(e) => dispatch(setPhone(e.target.value))}
                                error={!!errors.phone}
                                helperText={errors.phone}
                                required
                            />
                        </Box>
                        <Box mb={2}>
                            <TextField
                                fullWidth
                                label="הודעה"
                                variant="outlined"
                                multiline
                                rows={4}
                                value={message}
                                onChange={(e) => dispatch(setMessage(e.target.value))}
                                error={!!errors.message}
                                helperText={errors.message}
                                required
                            />
                        </Box>
                        {submissionError && (
                            <Box mb={2}>
                                <Alert severity="error">{submissionError}</Alert>
                            </Box>
                        )}
                        <Box display="flex" justifyContent="center">
                            <Button variant="contained" color="primary" type="submit">
                                שלח
                            </Button>
                        </Box>
                    </form>
                </>
            )}
        </Container>
    );
}